import { render } from "./CustomCheckBox.vue?vue&type=template&id=5892e094"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"

import "./CustomCheckBox.vue?vue&type=style&index=0&id=5892e094&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__